angular.module('Itao.IndicatorMap').directive('districtOverlay', function (mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtOverlay.html',
    replace: true,
    scope: {
      districtInfo: '='
    },
    link: function (scope, element) {
    }
  };
});
